import digitalPrinting from "./templates/digital-printing";

export default [
  {
    id: `material`,
    title: `Качество`,
    content: {
      description: `<p>Набор бомбоньерка ракушка на 5 шоколадок.<br/>Размер: 70х70мм / Вес: 25 г<br>Наполнение: 5 шоколадок по 5 г</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${digitalPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
